import React, { Suspense, useEffect, lazy } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
// import { useKeycloak } from '@react-keycloak/web';
// import _get from 'lodash/get';
// import actionCable from 'actioncable';

import { isLoadingState, notificationAlertState } from '../../state';
// import { httpRequest } from '../../utils';
// import { API, ACTION_CABLE_URL } from '../../config';
import NoMatch from '../NoMatch';
import ErrorBoundary from '../ErrorBoundary';
import Loader from '../Loader';
import AppHeader from '../AppHeader';
// import AppFooter from '../AppFooter';
import Can from '../Can';
import './BaseLayout.scss';
// import {
//   getUtmEnabledLink,
//   utmSource,
//   UTM_CAMPAIGN,
//   UTM_MEDIUM,
// } from '../../helpers/utmHelper';

const HomePage = lazy(() => import('../../views/HomePage'));
const SchoolProfilePage = lazy(() => import('../../views/SchoolProfilePage'));
const AdminPanel = lazy(() => import('../../admin/views/AdminPanel'));

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  // root: {
  //   display: 'flex',
  //   flexWrap: 'wrap',
  // },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  // drawerHeader: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   padding: theme.spacing(0, 1),
  //   // necessary for content to be below app bar
  //   ...theme.mixins.toolbar,
  //   justifyContent: 'flex-end',
  // },
  content: {
    flexGrow: 1,
    // paddingTop: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  listItemLink: {
    textDecoration: 'none',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  menuWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftCol: {
    display: 'flex',
    alignItems: 'center',
  },
}));

// const getCableApp = (token) => ({
//   cable: actionCable.createConsumer(
//     `${ACTION_CABLE_URL}/notification?token=${token}`,
//   ),
// });

export default function BaseLayout() {
  const classes = useStyles();
  const location = useLocation();
  // const { keycloak } = useKeycloak();
  // const [open] = useState(false);

  const isLoading = useRecoilValue(isLoadingState);
  const [notificationAlert, setNotificationAlert] = useRecoilState(
    notificationAlertState,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // const setupRealtimeNotifications = useCallback(() => {
  //   getCableApp(keycloak.token).cable.subscriptions.create(
  //     { channel: 'ReactConnectionChannel', keycloak_user_id: keycloak.subject },
  //     {
  //       received: (res) => {
  //         const notification = res.data;
  //         if (notification != null) {
  //           // TODO: All messages might not always have message, so handle it here
  //           console.log('Notification', notification);
  //           setTransactionalNotifications((prev) => {
  //             if (prev.find((t) => t.id === notification.id)) {
  //               return prev;
  //             }
  //             return [notification, ...prev];
  //           });
  //         }
  //       },
  //     },
  //   );
  // }, [keycloak, setTransactionalNotifications]);

  // useEffect(() => {
  //   if (keycloak && keycloak.authenticated) {
  //     if (window.dtrum && window.dtrum.identifyUser) {
  //       window.dtrum.identifyUser(keycloak.tokenParsed.email);
  //     }
  //     setupRealtimeNotifications();
  //   } else {
  //     getCableApp(keycloak.token).cable.disconnect();
  //   }
  //   fetchNotifications();
  // }, [fetchNotifications, keycloak, setupRealtimeNotifications]);

  return (
    <ErrorBoundary>
      <div className={classes.root}>
        {
          // location.pathname !== '/admin-panel'
          !location.pathname.includes('admin-panel') &&
            !location.pathname.includes('external') && <AppHeader />
        }
        <main
        // className={clsx(classes.content, {
        //   [classes.contentShift]: open,
        // })}
        >
          <div className={classes.drawerHeader} />
          <Suspense fallback={<Loader />}>
            <Switch>
              <Redirect from="/:url*(/+)" to={location.pathname.slice(0, -1)} />
              <Route exact path="/">
                <HomePage />
              </Route>
              <Route exact path="/schools">
                <HomePage />
              </Route>
              <Route exact path="/school/:schoolId">
                <SchoolProfilePage />
              </Route>
              <Route path="/admin-panel">
                <Can
                  // access={[USER_ROLE.ADMIN, USER_ROLE.MEMBER]}
                  redirectTo="/"
                >
                  <AdminPanel />
                </Can>
              </Route>
              <Route exact path="/not-found">
                <NoMatch />
              </Route>
              <Redirect to="/not-found" />
            </Switch>
            {
              // location.pathname !== '/admin-panel'
              // !location.pathname.includes('admin-panel') &&
              //   !location.pathname.includes('external') && <AppFooter />
            }
          </Suspense>
        </main>
        {isLoading && <Loader />}
        {notificationAlert && (
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open
            autoHideDuration={6000}
            onClose={() => setNotificationAlert()}
            onExited={() => setNotificationAlert()}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              onClose={() => setNotificationAlert()}
              severity={notificationAlert.type}
            >
              {notificationAlert.msg}
            </MuiAlert>
          </Snackbar>
        )}
      </div>
    </ErrorBoundary>
  );
}
